import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoReplay from '@/components/UI/svg/Icons/EFVideoReplay';
import EFVideo from '@/components/UI/EFVideo';

export default function MhTextD() {
    const { useEffect, useLang, useRouter, isMobile, useRef } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('waveportableairconditioner');
    const videoRef = useRef(null);
    const video2Ref = useRef(null);
    const videoExtMap: any = {
        us: 'fahrenheit',
        jp: 'celsius',
        cn: 'celsius',
        au: 'celsius',
        ca: 'celsius',
        za: 'celsius',
        sa: 'celsius',
    };
    const videoLocal = videoExtMap[locale] || videoExtMap['us'];
    let isEnter: any = false;

    const replayVideo1 = () => {
        try {
            videoRef.current?.play();
        } catch (e: any) {}
    };
    const replayVideo2 = () => {
        try {
            video2Ref.current?.play();
        } catch (e: any) {}
    };
    const onScroll = () => {
        const el = document.querySelector('.mhTextD') as HTMLElement;
        if (el?.scrollTop > 0 && !isEnter) {
            replayVideo1();
            replayVideo2();
            isEnter = true;
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', onScroll);
    }, []);

    return (
        <div className={`${css.mhTextD} mhTextD ${isMobile ? 'mhTextD-h5' : 'mhTextD-pc'}`}>
            <div className="mh-inter">
                <div className="list-item">
                    <div className="video-box">
                        <EFVideo
                            ref={videoRef}
                            className="video"
                            sources={[`/video/Mh200/ac_1_${videoLocal}.webm`, `/video/Mh200/ac_1_${videoLocal}.mp4`]}
                            loop={false}
                        />
                        <span className="btn-video-play" onClick={replayVideo1}>
                            <EFVideoReplay />
                        </span>
                    </div>
                    <div className="msg-line">{t('mh200.mhTD_ms1')}</div>
                </div>
                <div className="list-item">
                    <div className="video-box">
                        <EFVideo ref={video2Ref} className="video" sources={['/video/Mh200/ac_2.webm', '/video/Mh200/ac_2.mp4']} loop={false} />
                        <span className="btn-video-play" onClick={replayVideo2}>
                            <EFVideoReplay />
                        </span>
                    </div>
                    <div className="msg-line">{t('mh200.mhTD_ms2')}</div>
                </div>
            </div>
        </div>
    );
}
